// extracted by mini-css-extract-plugin
export default {"paginador":"Paginador_paginador__N-ZsH","boton":"Paginador_boton__4zKeG","presionado":"Paginador_presionado__HcDWv"};